import type { TablerIconsProps } from '@tabler/icons-react';

export function PriorityHighIcon({
	color,
	...rest
}: Omit<TablerIconsProps, 'stroke'>) {
	return (
		<svg fill={color} width="16" height="16" viewBox="0 0 16 16" {...rest}>
			<rect x="1" y="8" width="3" height="6" rx="1" />
			<rect x="6" y="5" width="3" height="9" rx="1" />
			<rect x="11" y="2" width="3" height="12" rx="1" />
		</svg>
	);
}

export function PriorityMediumIcon({
	color,
	...rest
}: Omit<TablerIconsProps, 'stroke'>) {
	return (
		<svg fill={color} width="16" height="16" viewBox="0 0 16 16" {...rest}>
			<rect x="1" y="8" width="3" height="6" rx="1" />
			<rect x="6" y="5" width="3" height="9" rx="1" />
			<rect x="11" y="2" width="3" height="12" rx="1" fillOpacity="0.3" />
		</svg>
	);
}

export function PriorityLowIcon({
	color,
	...rest
}: Omit<TablerIconsProps, 'stroke'>) {
	return (
		<svg fill={color} width="16" height="16" viewBox="0 0 16 16" {...rest}>
			<rect x="1" y="8" width="3" height="6" rx="1" />
			<rect x="6" y="5" width="3" height="9" rx="1" fillOpacity="0.3" />
			<rect x="11" y="2" width="3" height="12" rx="1" fillOpacity="0.3" />
		</svg>
	);
}

export function PriorityNoneIcon({
	color,
	...rest
}: Omit<TablerIconsProps, 'stroke'>) {
	return (
		<svg fill={color} width="16" height="16" viewBox="0 0 14 14" {...rest}>
			<rect width="2" height="2" rx="1" transform="matrix(-1 0 0 1 5 6)" />
			<rect width="2" height="2" rx="1" transform="matrix(-1 0 0 1 8 6)" />
			<rect width="2" height="2" rx="1" transform="matrix(-1 0 0 1 11 6)" />
		</svg>
	);
}
